/**
 * 移动端「Claim Deal」底部固定条 (claim-deal-bar)
 * - PC 端不展示（由分区 CSS 控制）
 * - 页面顶部隐藏，向下滚动超过阈值后从底部弹出并保持固定
 * - 按钮为 <a>：点击时拼接 /cart/add?id=[Variant_ID]&quantity=[数量]&return_to=/cart 加购并跳转购物车页
 * - 数量：优先 hero-video-early-bird，其次 product-buy-box，再次 main-product(.quantity__input)，默认 1
 */
(function () {
  'use strict';

  class ClaimDealBar extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.getAttribute('data-scroll-threshold'), 10);
      if (!(this.threshold >= 0)) this.threshold = 300;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);
    }

    connectedCallback() {
      this.cta = this.querySelector('[data-claim-deal-button]');
      this.setupCta();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.updateVisibility, { passive: true });
      this.updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.updateVisibility);
    }

    // 加购按钮：默认取产品页 selected_or_first_available_variant，
    // 可在分区配置中指定兜底变体。功能写死为“转跳到购物车页面并加购”。
    setupCta() {
      if (!this.cta) return;
      this.cartAddBase = this.cta.getAttribute('data-cart-add-base') || '/cart/add';
      this.cartReturnTo = this.cta.getAttribute('data-cart-return-to') || '/cart';
      this.variantId = this.cta.getAttribute('data-variant-id') || '';

      this.updateCtaHref();
      this.cta.addEventListener('click', (event) => {
      if (this.loading) {
        event.preventDefault();
        return;
      }
      const url = this.buildCartUrl();
      if (!url) {
        event.preventDefault();
        return;
      }
      this.cta.setAttribute('href', url);
      this.setLoading();
    });
  }

  // 进入加载态：显示 spinner 并锁定按钮，跳转前不可再次点击
  setLoading() {
    this.loading = true;
    this.cta.classList.add('is-loading');
    this.cta.setAttribute('aria-busy', 'true');
  }

  updateCtaHref() {
      const url = this.buildCartUrl();
      if (url) {
        this.cta.setAttribute('href', url);
        this.cta.removeAttribute('aria-disabled');
      } else {
        this.cta.setAttribute('aria-disabled', 'true');
      }
    }

    // 数量：优先 hero-video-early-bird，其次 product-buy-box，再次 main-product(.quantity__input)，默认 1
    getQuantity() {
      const input =
        document.querySelector('.hero-video-early-bird__quantity-input') ||
        document.querySelector('.product-buy-box__quantity-input') ||
        document.querySelector('.product-form__quantity .quantity__input');
      const qty = input ? parseInt(input.value, 10) : NaN;
      return qty > 0 ? qty : 1;
    }

    buildCartUrl() {
      const variantId = (this.variantId || '').trim();
      if (!/^\d+$/.test(variantId) || variantId === '0') return '';
      const base = this.cartAddBase.replace(/\/$/, '');
      return (
        base +
        '?id=' +
        encodeURIComponent(variantId) +
        '&quantity=' +
        encodeURIComponent(this.getQuantity()) +
        '&return_to=' +
        encodeURIComponent(this.cartReturnTo)
      );
    }

    onScroll() {
      if (!this.ticking) {
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.updateVisibility();
          this.ticking = false;
        });
      }
    }

    // 滚动固定逻辑：顶部隐藏，向下滚动超过阈值后从底部弹出并保持固定
    updateVisibility() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollY >= this.threshold) {
        this.classList.add('claim-deal-bar--show');
      } else {
        this.classList.remove('claim-deal-bar--show');
      }
    }
  }

  if (!window.customElements.get('claim-deal-bar')) {
    customElements.define('claim-deal-bar', ClaimDealBar);
  }
})();
